import { Box, Grid, Typography } from "@mui/material";
import moment from "moment";
import { CardLayout } from "../v3";

const OverviewCard = ({ label, value, total, color = "text.primary" }) => {
  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        bgcolor: "grey.100",
        height: "100%",
      }}
    >
      <Typography variant="caption" color="text.secondary" display="block" mb={0.5}>
        {label}
      </Typography>

      <Typography variant="h5" fontWeight={700} sx={{ color }}>
        {value}
        {total !== undefined && (
          <Typography component="span" variant="body2" fontWeight={500} color="text.secondary">
            {" "}/ {total}
          </Typography>
        )}
      </Typography>
    </Box>
  );
};

const startOfToday = () => moment().startOf("day");
const endOfToday = () => moment().endOf("day");

const isOverdueIncomplete = (task: any) => {
  if (task?.status === "DONE" || task?.isCompleted || !task?.dueDate) return false;
  return moment(task.dueDate).isBefore(startOfToday(), "day");
};

const isDueTodayIncomplete = (task: any) => {
  if (task?.status === "DONE" || task?.isCompleted || !task?.dueDate) return false;
  const d = moment(task.dueDate);
  return d.isSameOrAfter(startOfToday()) && d.isSameOrBefore(endOfToday());
};

export const LeadTaskOverview = ({ tasks = [] }) => {
  const total = tasks.length;
  const notDoneCount = tasks.filter((task: any) => task?.status !== "DONE" && !task?.isCompleted).length;

  let todoCount = 0;
  let inProgressCount = 0;
  let dueCount = 0;
  let overdueCount = 0;

  for (const task of tasks) {
    if (task?.status === "DONE" || task?.isCompleted) continue;

    if (isOverdueIncomplete(task)) {
      overdueCount += 1;
    }

    if (isDueTodayIncomplete(task)) {
      dueCount += 1;
    }

    if (task?.status === "INPROGRESS") {
      inProgressCount += 1;
    } else {
      todoCount += 1;
    }
  }

  return (
    <CardLayout
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 3,
        p: 2,
      }}
    >
      <Typography variant="subtitle2" fontWeight={600} mb={2}>
        Task Overview
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={2.4}>
          <OverviewCard label="Total tasks" value={notDoneCount} total={total} />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={2.4}>
          <OverviewCard label="Todo" value={todoCount} color="info.main" />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={2.4}>
          <OverviewCard label="In Progress" value={inProgressCount} color="warning.main" />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={2.4}>
          <OverviewCard label="Due today" value={dueCount} color="primary.main" />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={2.4}>
          <OverviewCard label="Overdue" value={overdueCount} color="error.main" />
        </Grid>
      </Grid>
    </CardLayout>
  );
};
